export enum LocationTypeColor {
  ImportFromCSV = '#AJ6600',
  MasterLocation = '#2ABB7F',
  ManualEntry = '#FF7700',
}
